

export const ENTITY_FORM_ACTIONS = {
    NORMAL: "normal",
    ONLY_SELECT: "onlySelect",
    ONLY_SELECT_AND_VIEW: "onlySelectAndView"
};
